// tslint:disable:max-line-length
import { Component, OnInit } from '@angular/core';
import { E5coreUiWorkFieldTypeTextBaseComponent } from '../../../components/e5core-ui-work-field-type-text/component/e5core-ui-work-field-type-text-base';

@Component({
  selector: 'e5core-ui-work-field-type-user-material',
  templateUrl: './e5core-ui-work-field-type-user-material.component.html',
  styleUrls: ['./e5core-ui-work-field-type-user-material.component.css']
})
export class E5coreUiWorkFieldTypeUserMaterialComponent extends E5coreUiWorkFieldTypeTextBaseComponent {

}
